var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReceipt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.375 20.7466C9.375 19.2968 10.5503 18.1216 12 18.1216C13.4497 18.1216 14.625 19.2968 14.625 20.7466H17.25C18.2165 20.7466 19 19.9631 19 18.9966V4.99658C19 4.03008 18.2165 3.24658 17.25 3.24658H6.75C5.7835 3.24658 5 4.03008 5 4.99658V18.9966C5 19.9631 5.7835 20.7466 6.75 20.7466H9.375ZM6.75 12.8716C6.75 13.3548 7.14178 13.7466 7.625 13.7466H16.375C16.8582 13.7466 17.25 13.3548 17.25 12.8716C17.25 12.3883 16.8582 11.9966 16.375 11.9966H7.625C7.14178 11.9966 6.75 12.3883 6.75 12.8716ZM11.125 10.2466C10.6418 10.2466 10.25 9.85482 10.25 9.37158C10.25 8.88834 10.6418 8.49658 11.125 8.49658H16.375C16.8582 8.49658 17.25 8.88834 17.25 9.37158C17.25 9.85482 16.8582 10.2466 16.375 10.2466H11.125Z",
    fill: "#B8B8B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceipt);
export default __webpack_public_path__ + "static/media/receipt.460a111c29f9c2f66d66df806cea2392.svg";
export { ForwardRef as ReactComponent };